import { createActionGroup, emptyProps } from "@ngrx/store";
import { LobbyErrors } from "src/app/core/models/common/lobby-error.model";

export const ErrorAction = createActionGroup({
    source: 'Shared',
    events: {
        'invalid operation error': (errors: LobbyErrors) => ({ errors }),
        'forbidden operation error': (errors: LobbyErrors) => ({ errors }),
        'generic error': (message: string | undefined) => ({ message }),
        'unkonwn error': emptyProps()
    }
})
